module.exports = __webpack_public_path__ + "img/spirit_600.096a326f.png";